import { useQuery } from "@tanstack/react-query";
import { gateway } from "../../../../gateway";

export interface BulkResolvedContact {
  name?: string;
  role?: string;
  firstName?: string;
  lastName?: string;
  type?: string;
  uid?: string;
  phone?: string;
  businessName?: string | null;
}

export type BulkResolvedMap = Record<string, BulkResolvedContact>;

export const BULK_RESOLVE_QUERY_KEY = ["sms", "contacts", "bulk-resolve"] as const;

export const useBulkResolveContacts = (phoneNumbers: string[]) => {
  const serializedPhones = phoneNumbers.join(",");

  return useQuery<BulkResolvedMap, Error>({
    queryKey: [...BULK_RESOLVE_QUERY_KEY, serializedPhones],
    queryFn: async (): Promise<BulkResolvedMap> => {
      if (phoneNumbers.length === 0) return {};
      const { data } = await gateway.post("/contact-center/bulk-resolve", {
        phoneNumbers,
      });
      return data?.data || {};
    },
    enabled: phoneNumbers.length > 0,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
